import {IonContent} from "@ionic/react";
import AdminEntityList from "../../components/admin/AdminEntityList";

export const AdminUsers: React.FC = () => {
    return (
        <IonContent>
            <AdminEntityList />
        </IonContent>
    );
}